export { default, type IProps } from "./RadioGroup";
